import React, { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import { forgotPassword } from '../../api/userApi';
import './ForgotPassword.css';
import HomeButton from '../common/HomeButton';

const RECAPTCHA_SITE_KEY = window.process.env.RECAPTCHA_SITE_KEY;

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const recaptcha = useRef();


    const { t } = useTranslation();
    const navigate = useNavigate();

/*     const handleCaptchaChange = (token) => {
        try {
            setCaptchaToken(token);
        } catch (error) {
            console.log(error);
        }
    };
 */
    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');

        const captchaValue = recaptcha.current.getValue();

        if (!captchaValue) {
            setError(t('forgotPassword.completeCaptcha'));
            recaptcha.current?.reset();
            return;
        }

        try {
            await forgotPassword({ email, captchaValue });
            setMessage(t('forgotPassword.emailSent'));
        } catch (error) {
            if (error.response && error.response.status === 429) {
                setError(t('forgotPassword.tooManyRequests'))
            } else if (error.response && error.response.status === 404) {
                if (error.response.data.message === 'CAPTCHA verification failed') {
                    setError(t('forgotPassword.completeCaptcha'));  
                } else {
                    setError(t('forgotPassword.emailNotFound'));
                }
            } else {
                setError(t('forgotPassword.resetFailed'));
            }
            recaptcha.current?.reset();
        }
    };

    return (
        <div className="forgot-password-component">
            <HomeButton />
            <form className='forgot-password-form' onSubmit={handleSubmit}>
                <input
                    type="email"
                    value={email}
                    placeholder={t('forgotPassword.email')}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <div className='captcha'>
                    <ReCAPTCHA
                        sitekey={RECAPTCHA_SITE_KEY}
                        ref={recaptcha}
                        theme='dark'
                    />
                </div>
                <button className='big-button action-button' type="submit">
                    <i className="fa-solid fa-share"></i>
                    <span>{t('forgotPassword.sendResetLink')}</span>
                </button>
            </form>
            {message && <p className="message">{message}</p>}
            {error && <p className='form-error'>{error}</p>}
            <h2 className='forgot-password-h2'> <button className='link-button' onClick={() => navigate('/login')}>{t('forgotPassword.backToLogin')}</button></h2>
        </div>
    );
};

export default ForgotPassword;
